module.exports = __webpack_public_path__ + "img/manufacture.402e805.webp";